import { DialogUI } from '../../Interface';
import { useProduction } from '../../../hooks/useProduction';
import { useEffect, useState } from 'react';
import { ProductionPage } from '../../Production/NewProduction/ProductionPage';

const ProductionDialog = ({ dialogData, handleClose, changed }) => {
  const { open, data } = dialogData;
  const { setRefetch } = changed;
  const productionState = useProduction();

  return (
    <DialogUI
      open={open}
      onClose={handleClose}
      headerContent="Gyártás létrehozása"
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '800px',
          },
        },
      }}
    >
      <div className="mt-5">
        <ProductionPage
          dialog={{
            handleClose: handleClose,
            setProductionChanged: setRefetch,
            dialogData: data,
          }}
          productionState={productionState}
        />
      </div>
    </DialogUI>
  );
};

export default ProductionDialog;
